<template>
  <div class="pane-box">

    <div class="pane-label">
      <div></div>{{label}}
    </div>

    <div class="pane-photo" v-if="dataList.length > 0">
      <el-image v-for="(item,i) in dataList" :key="i" class="pane-photo-img" :src="item" :preview-src-list="dataList">
      </el-image>
    </div>

    <div class="pane-photo" v-if="dataList.length <= 0">
        <div class="no-file">
          <i class="el-icon-warning-outline"></i>
          <span>暂未上传</span>
        </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      label: {
        type: String,
        default: null
      },
      srcList: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        dataList: []
      }
    },
    methods: {},
    mounted() {
      this.dataList = this.srcList != null ? this.srcList.split(',') : [];
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/style/mixin";

  .pane-box {
  }

  .pane-label {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 32px;

    div {
      width: 5px;
      height: 14px;
      border-radius: 2px;
      background-color: #00a5d5;
      margin-right: 10px;
    }

  }

  .pane-photo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    background: #ececec;
    border-radius: 5px;
    padding: 10px 15px;
    margin: 5px 0;
  }

  .pane-photo-img {
    width: 60px;
    height: 60px;
    border-radius: 5px;
    margin-right: 10px;
  }


  .no-file {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 28px;

    i {
      font-size: 15px;
    }

    span {
      font-size: 13px;
      margin-left: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// detailPhoto.vue?4a2b3c30